import { createSelector } from "@reduxjs/toolkit";
import { selectActiveViewState } from "views/logic/slices/viewSelectors";
export const selectHighlightingRules = createSelector(
  selectActiveViewState,
  (viewState) => {
    var _a, _b;
    return (_b = (_a = viewState == null ? void 0 : viewState.formatting) == null ? void 0 : _a.highlighting) != null ? _b : [];
  }
);
